import { css } from '@emotion/react';

import { colors } from 'src/styles/colors';
import { MediaBP as MQ } from 'src/styles/mediaQuery';

export const skeletonRailsContainer = css`
  width: 100%;
  padding-left: 16px;
  padding-bottom: 16px;
  display: inline-block;
  &:first-of-type {
    margin-top: 20px;
  }
  ${MQ.MediaSm} {
    padding-left: 0;
  }
`;
export const skeletonRailsHeaderStyle = css`
  &::before {
    content: '';
    border-radius: 6px;
    background-color: ${colors.TemplateLoaderAccent};
    width: 192px;
    height: 30px;
    display: block;
    margin-bottom: 13px;
  }
`;
export const skeletonRecommendedContentContainer = css`
  display: none;
  ${MQ.MediaLg} {
    overflow: hidden;
    position: relative;
    flex-basis: 35%;
    display: block;
  }
  ${MQ.MediaXl} {
    flex-basis: 30%;
  }
`;
export const skeletonRecommendedContentTitle = css`
  height: 20px;
  margin-bottom: 16px;
  margin-left: 10px;
  width: 77%;
  border-radius: 10px;
  background: ${colors.tuna};
`;
export const skeletonWrapper = css`
  display: flex;
  flex-direction: row;
`;
export const skeletonVideoContainer = css`
  flex-basis: 65%;
`;
export const recommenededRailContainer = css`
  display: flex;
  flex-wrap: wrap;
`;
